import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  VariantFormFieldValue,
  VariantPlaceholderText,
} from 'modules/experiments/components/pages/edit/sections/variant_configuration/CommonStyled';

export const ReadOnlyValue: React.FC<React.PropsWithChildren<{ dataTest?: string }>> = ({
  children,
  dataTest,
}) => {
  const { t } = useExperimentsTranslations();

  return children ? (
    <VariantFormFieldValue data-test={dataTest}>{children}</VariantFormFieldValue>
  ) : (
    <VariantPlaceholderText data-test={dataTest}>
      {t('variantCard.fieldPlaceholderText.notSet')}
    </VariantPlaceholderText>
  );
};
